import { Typography } from "../../../../../../shared/frontend/ui";
import React from "react";
import { Navigate,useParams } from "react-router-dom";
import { tenantCapabilityWithFallback } from "../../app/auth/tenantCapabilitiesRead";
import { useAuth } from "../../app/auth/useAuth";
import { useI18n } from "../../app/i18n/useI18n";
import { NavCardGrid } from "../../components/NavCardGrid";
import { reportIcon } from "./reportIcons";
import { reportsCatalogGroups } from "./reportsCatalog";
import { ARTICLE_SALES_REPORT_PATH, REPORT_GROUP_KEY_CALENDAR, REPORT_GROUP_KEY_LEADS } from "./components/reportValues";

export function ReportsGroupPage() {
  const { groupKey } = useParams<{ groupKey: string }>();
  const auth = useAuth();
  const { text } = useI18n();

  // Der URL-Schlüssel steht am Katalogeintrag selbst — eine zweite Zuordnungstabelle hier würde
  // bei jeder neuen Gruppe stumm veralten.
  const group = reportsCatalogGroups.find((g) => g.key === groupKey);
  const rawCaps = auth.info?.capabilities;
  const hasCalendar = tenantCapabilityWithFallback(rawCaps, "calendar", auth.info?.moduleCalendarEnabled ?? false);
  const hasLeadManager = tenantCapabilityWithFallback(rawCaps, "leadManager", auth.info?.moduleLeadManagerEnabled ?? false);
  const hasReports = tenantCapabilityWithFallback(rawCaps, "reports", true);
  const hasArticleSales = tenantCapabilityWithFallback(rawCaps, "articleSales", false);

  if (!group) {
    return (
      <div>
        <Typography.Text type="danger">{text("Group not found")}</Typography.Text>
      </div>
    );
  }

  if (!hasReports || (groupKey === REPORT_GROUP_KEY_CALENDAR && !hasCalendar) || (groupKey === REPORT_GROUP_KEY_LEADS && !hasLeadManager)) {
    return <Navigate to="/forbidden" replace />;
  }

  // Gruppe nur anzeigen, wenn Berechtigung vorhanden (konsistent mit ReportsHomePage/Menü).
  if (group.requiredPermissions?.length && !auth.hasAnyPermission(...(group.requiredPermissions ?? []))) {
    return <Navigate to="/forbidden" replace />;
  }

  const items = group.items
    .filter((item) => item.path !== ARTICLE_SALES_REPORT_PATH || hasArticleSales)
    .map((item) => ({
      titleKey: item.labelKey,
      descriptionKey: item.description,
      icon: reportIcon(item.iconKey),
      path: item.path
    }));

  return (
    <NavCardGrid title={text(group.labelKey)} items={items} text={text} />
  );
}





